var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggleSidebar"},[_c('sidebar_user',{attrs:{"setorders":_vm.orders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }